import { useState } from 'react';
import { useSelector } from 'react-redux';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import EditFormSubComponent from 'modules/ui/editform/subForm/EditFormSubComponent';
import InfrastructureElementEditService from '../service/InfrastructureElementEditService';

const config = data => {
	return {
		key: 'infrastructureElementEditForm',
		text: 'Infrastructure Element',
		textKey: 'infrastructureElement',
		service: InfrastructureElementEditService,
		tabList: [
			{
				key: 'element',
				text: 'Element',
				textKey: 'element'
			},
			{
				key: 'locationList',
				text: 'Location',
				textKey: 'locationList'
			}
		],
		fields: [
			{
				key: 'name',
				text: 'Name',
				textKey: 'name',
				component: EditFormTextField,
				required: true
			},
			{
				key: 'project',
				text: 'Project',
				textKey: 'Project',
				component: EditFormSelectField,
				items: data.formData.entityMap.project,
				visibleIf: () => data.user.isSuperAdmin,
				required: true
			},
			{
				key: 'elementType',
				text: 'Element type',
				textKey: 'elementType',
				component: EditFormSelectField,
				items: data.formData.entityMap.elementType
			},
			{
				key: 'gpsGroup',
				component: EditFormGroupFields,
				className: 'w-full flex flex-col sm:flex-row',
				fields: [
					{
						key: 'coordLat',
						text: 'GPS Latitude',
						textKey: 'coordLat',
						className: 'sm:mr-6',
						component: EditFormTextField,
						required: true,
						maxLength: 50
					},
					{
						key: 'coordLng',
						text: 'GPS Longitude',
						textKey: 'coordLng',
						component: EditFormTextField,
						required: true,
						maxLength: 50
					}
				]
			},
			{
				key: 'locationList',
				text: 'Location',
				textKey: 'locationList',
				tab: 'locationList',
				component: EditFormSubComponent,
				watchTitleKey: 'name',
				defaultValue: {
					id: null,
					name: null
				},
				fields: [
					{
						key: 'name',
						text: 'Name',
						textKey: 'name',
						component: EditFormTextField,
						required: true
					}
				]
			}
		]
	};
};

function InfrastructureElementEditForm() {
	const user = useSelector(({ auth }) => auth.user);
	const [formData, setFormData] = useState(null);
	if (formData == null) {
		InfrastructureElementEditService.getFormData().then(result => setFormData(result));
		return <></>;
	}
	const myConfig = config({ formData, user });
	return <EditFormPage config={myConfig} />;
}

export default InfrastructureElementEditForm;
